"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CoordinateList = _interopRequireDefault(require("./CoordinateList"));

var _Coordinate = _interopRequireDefault(require("./Coordinate"));

var _MathUtil = _interopRequireDefault(require("../math/MathUtil"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _Comparator = _interopRequireDefault(require("../../../../java/util/Comparator"));

var _Envelope = _interopRequireDefault(require("./Envelope"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CoordinateArrays =
/*#__PURE__*/
function () {
  function CoordinateArrays() {
    _classCallCheck(this, CoordinateArrays);

    CoordinateArrays.constructor_.apply(this, arguments);
  }

  _createClass(CoordinateArrays, [{
    key: "getClass",
    value: function getClass() {
      return CoordinateArrays;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isRing",
    value: function isRing(pts) {
      if (pts.length < 4) return false;
      if (!pts[0].equals2D(pts[pts.length - 1])) return false;
      return true;
    }
  }, {
    key: "ptNotInList",
    value: function ptNotInList(testPts, pts) {
      for (var i = 0; i < testPts.length; i++) {
        var testPt = testPts[i];
        if (CoordinateArrays.indexOf(testPt, pts) < 0) return testPt;
      }

      return null;
    }
  }, {
    key: "scroll",
    value: function scroll(coordinates, firstCoordinate) {
      var i = CoordinateArrays.indexOf(firstCoordinate, coordinates);
      if (i < 0) return null;
      var newCoordinates = new Array(coordinates.length).fill(null);

      _System.default.arraycopy(coordinates, i, newCoordinates, 0, coordinates.length - i);

      _System.default.arraycopy(coordinates, 0, newCoordinates, coordinates.length - i, i);

      _System.default.arraycopy(newCoordinates, 0, coordinates, 0, coordinates.length);
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 2) {
        var coord1 = arguments[0],
            coord2 = arguments[1];
        if (coord1 === coord2) return true;
        if (coord1 === null || coord2 === null) return false;
        if (coord1.length !== coord2.length) return false;

        for (var i = 0; i < coord1.length; i++) {
          if (!coord1[i].equals(coord2[i])) return false;
        }

        return true;
      } else if (arguments.length === 3) {
        var _coord = arguments[0],
            _coord2 = arguments[1],
            coordinateComparator = arguments[2];
        if (_coord === _coord2) return true;
        if (_coord === null || _coord2 === null) return false;
        if (_coord.length !== _coord2.length) return false;

        for (var i = 0; i < _coord.length; i++) {
          if (coordinateComparator.compare(_coord[i], _coord2[i]) !== 0) return false;
        }

        return true;
      }
    }
  }, {
    key: "intersection",
    value: function intersection(coordinates, env) {
      var coordList = new _CoordinateList.default();

      for (var i = 0; i < coordinates.length; i++) {
        if (env.intersects(coordinates[i])) coordList.add(coordinates[i], true);
      }

      return coordList.toCoordinateArray();
    }
  }, {
    key: "hasRepeatedPoints",
    value: function hasRepeatedPoints(coord) {
      for (var i = 1; i < coord.length; i++) {
        if (coord[i - 1].equals(coord[i])) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "removeRepeatedPoints",
    value: function removeRepeatedPoints(coord) {
      if (!CoordinateArrays.hasRepeatedPoints(coord)) return coord;
      var coordList = new _CoordinateList.default(coord, false);
      return coordList.toCoordinateArray();
    }
  }, {
    key: "reverse",
    value: function reverse(coord) {
      var last = coord.length - 1;
      var mid = Math.trunc(last / 2);

      for (var i = 0; i <= mid; i++) {
        var tmp = coord[i];
        coord[i] = coord[last - i];
        coord[last - i] = tmp;
      }
    }
  }, {
    key: "removeNull",
    value: function removeNull(coord) {
      var nonNull = 0;

      for (var i = 0; i < coord.length; i++) {
        if (coord[i] !== null) nonNull++;
      }

      var newCoord = new Array(nonNull).fill(null);
      if (nonNull === 0) return newCoord;
      var j = 0;

      for (var i = 0; i < coord.length; i++) {
        if (coord[i] !== null) newCoord[j++] = coord[i];
      }

      return newCoord;
    }
  }, {
    key: "copyDeep",
    value: function copyDeep() {
      if (arguments.length === 1) {
        var coordinates = arguments[0];
        var copy = new Array(coordinates.length).fill(null);

        for (var i = 0; i < coordinates.length; i++) {
          copy[i] = new _Coordinate.default(coordinates[i]);
        }

        return copy;
      } else if (arguments.length === 5) {
        var src = arguments[0],
            srcStart = arguments[1],
            dest = arguments[2],
            destStart = arguments[3],
            length = arguments[4];

        for (var i = 0; i < length; i++) {
          dest[destStart + i] = new _Coordinate.default(src[srcStart + i]);
        }
      }
    }
  }, {
    key: "isEqualReversed",
    value: function isEqualReversed(pts1, pts2) {
      for (var i = 0; i < pts1.length; i++) {
        var p1 = pts1[i];
        var p2 = pts2[pts1.length - i - 1];
        if (p1.compareTo(p2) !== 0) return false;
      }

      return true;
    }
  }, {
    key: "envelope",
    value: function envelope(coordinates) {
      var env = new _Envelope.default();

      for (var i = 0; i < coordinates.length; i++) {
        env.expandToInclude(coordinates[i]);
      }

      return env;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray(coordList) {
      return coordList.toArray(CoordinateArrays.coordArrayType);
    }
  }, {
    key: "atLeastNCoordinatesOrNothing",
    value: function atLeastNCoordinatesOrNothing(n, c) {
      return c.length >= n ? c : [];
    }
  }, {
    key: "indexOf",
    value: function indexOf(coordinate, coordinates) {
      for (var i = 0; i < coordinates.length; i++) {
        if (coordinate.equals(coordinates[i])) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "increasingDirection",
    value: function increasingDirection(pts) {
      for (var i = 0; i < Math.trunc(pts.length / 2); i++) {
        var j = pts.length - 1 - i;
        var comp = pts[i].compareTo(pts[j]);
        if (comp !== 0) return comp;
      }

      return 1;
    }
  }, {
    key: "compare",
    value: function compare(pts1, pts2) {
      var i = 0;

      while (i < pts1.length && i < pts2.length) {
        var compare = pts1[i].compareTo(pts2[i]);
        if (compare !== 0) return compare;
        i++;
      }

      if (i < pts2.length) return -1;
      if (i < pts1.length) return 1;
      return 0;
    }
  }, {
    key: "minCoordinate",
    value: function minCoordinate(coordinates) {
      var minCoord = null;

      for (var i = 0; i < coordinates.length; i++) {
        if (minCoord === null || minCoord.compareTo(coordinates[i]) > 0) {
          minCoord = coordinates[i];
        }
      }

      return minCoord;
    }
  }, {
    key: "extract",
    value: function extract(pts, start, end) {
      start = _MathUtil.default.clamp(start, 0, pts.length);
      end = _MathUtil.default.clamp(end, -1, pts.length);
      var npts = end - start + 1;
      if (end < 0) npts = 0;
      if (start >= pts.length) npts = 0;
      if (end < start) npts = 0;
      var extractPts = new Array(npts).fill(null);
      if (npts === 0) return extractPts;
      var iPts = 0;

      for (var i = start; i <= end; i++) {
        extractPts[iPts++] = pts[i];
      }

      return extractPts;
    }
  }]);

  return CoordinateArrays;
}();

exports.default = CoordinateArrays;

var ForwardComparator =
/*#__PURE__*/
function () {
  function ForwardComparator() {
    _classCallCheck(this, ForwardComparator);

    ForwardComparator.constructor_.apply(this, arguments);
  }

  _createClass(ForwardComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      return CoordinateArrays.compare(pts1, pts2);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ForwardComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }]);

  return ForwardComparator;
}();

ForwardComparator.constructor_ = function () {};

var BidirectionalComparator =
/*#__PURE__*/
function () {
  function BidirectionalComparator() {
    _classCallCheck(this, BidirectionalComparator);

    BidirectionalComparator.constructor_.apply(this, arguments);
  }

  _createClass(BidirectionalComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      if (pts1.length < pts2.length) return -1;
      if (pts1.length > pts2.length) return 1;
      if (pts1.length === 0) return 0;
      var forwardComp = CoordinateArrays.compare(pts1, pts2);
      var isEqualRev = CoordinateArrays.isEqualReversed(pts1, pts2);
      if (isEqualRev) return 0;
      return forwardComp;
    }
  }, {
    key: "OLDcompare",
    value: function OLDcompare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      if (pts1.length < pts2.length) return -1;
      if (pts1.length > pts2.length) return 1;
      if (pts1.length === 0) return 0;
      var dir1 = CoordinateArrays.increasingDirection(pts1);
      var dir2 = CoordinateArrays.increasingDirection(pts2);
      var i1 = dir1 > 0 ? 0 : pts1.length - 1;
      var i2 = dir2 > 0 ? 0 : pts1.length - 1;

      for (var i = 0; i < pts1.length; i++) {
        var comparePt = pts1[i1].compareTo(pts2[i2]);
        if (comparePt !== 0) return comparePt;
        i1 += dir1;
        i2 += dir2;
      }

      return 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BidirectionalComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }]);

  return BidirectionalComparator;
}();

BidirectionalComparator.constructor_ = function () {};

CoordinateArrays.ForwardComparator = ForwardComparator;
CoordinateArrays.BidirectionalComparator = BidirectionalComparator;

CoordinateArrays.constructor_ = function () {};

CoordinateArrays.coordArrayType = new Array(0).fill(null);